import { MarketSummary } from '../utils/dtc-commerce-mmm-markets';

export const MarketSortColumn = {
  MARKET: 'market',
  SPEND: 'spend',
  SPEND_PCT: 'spendPct',
  EFFECT: 'effect',
  EFFECT_PCT: 'effectPct',
  EFFICIENCY: 'efficiency'
} as const;
export type MarketSortColumnType = (typeof MarketSortColumn)[keyof typeof MarketSortColumn];

export const SortDirection = {
  ASC: 'asc',
  DESC: 'desc'
} as const;
export type SortDirectionType = (typeof SortDirection)[keyof typeof SortDirection];

// A market as the table shows it: its name resolved, and its ROAS or CPA by the model's KPI.
export interface MarketTableRow extends MarketSummary {
  displayName: string;
  efficiency: number | null;
}
